module.exports = __webpack_public_path__ + "static/media/room-7.0d326451.jpg";